












import { Component, Prop, Vue } from 'vue-property-decorator';

import SocialShareButton, {
  SocialShareButtonData
} from '@/componentsV2/molecules/SocialShareButton/SocialShareButton.vue';
import { EASocialMedia } from '@/components/molecules/SocialMediaButton/SocialMediaButton.vue';

export function defaultSocialNetworks() {
  return ['facebook', 'twitter', 'linkedin', 'copyLink'];
}

@Component({
  components: {
    SocialShareButton
  }
})
export default class ShareButtons extends Vue {
  @Prop({ default: () => defaultSocialNetworks() })
  networks?: EASocialMedia[];
  @Prop() shareData!: SocialShareButtonData[];
}
